<!-- Success Modal -->
<div class="modal fade" id="cartSuccessModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-body text-center p-4">
        <div class="success-animation mb-4">
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
        <h4 class="modal-title mb-3" id="successModalLabel">Added to Cart!</h4>
        <p class="text-muted mb-4">Your item has been added to the cart successfully.</p>
        <div class="d-flex justify-content-center gap-2">
          <button type="button" class="btn btn-outline-dark px-4 py-2" (click)="continueShopping()">
            Continue Shopping
          </button>
          <button type="button" class="btn btn-dark px-4 py-2" (click)="navigateToCart()">
            View Cart
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container mt-5">
    <div class="row">
        <!-- Product Images -->
        <div class="col-md-6 mb-4">
            <img src={{selectProduct.productImage}} alt="Product" class="img-fluid rounded mb-3 product-image" id="mainImage" >
            <div class="d-flex justify-content-between">
                <img src={{selectProduct.productImage}} alt="Thumbnail 1" class="thumbnail rounded active" onclick="changeImage(event, this.productDescription)">
                <img src={{selectProduct.productImage}} alt="Thumbnail 2" class="thumbnail rounded" onclick="changeImage(event, this.productDescription)">
                <img src={{selectProduct.productImage}} alt="Thumbnail 3" class="thumbnail rounded" onclick="changeImage(event, this.productDescription)">
                <img src={{selectProduct.productImage}} alt="Thumbnail 4" class="thumbnail rounded" onclick="changeImage(event, this.productDescription)">
            </div>
        </div>

        <!-- Product Details -->
        <div class="col-md-6">
            <h2 class="mb-3">{{selectProduct.productName }}</h2>
            <p>{{selectProduct.productDescription}}</p>
           <!--   <p class="text-muted mb-4">SKU: WH1000XM4</p>-->
            <div class="mb-3">
                <span class="h4 me-2">Rs.{{(selectProduct.productPrice - (selectProduct.productPrice * 0.5))*selectProduct.Quantity | number:'1.2-2'}}</span>
                <span class="text-muted"><s>Rs.{{selectProduct.productPrice*selectProduct.Quantity}}</s></span>
            </div>
            <div class="mb-3">
                <i class="bi bi-star-fill text-warning"></i>
                <i class="bi bi-star-fill text-warning"></i>
                <i class="bi bi-star-fill text-warning"></i>
                <i class="bi bi-star-fill text-warning"></i>
                <i class="bi bi-star-half text-warning"></i>
                <span class="ms-2">4.5 (120 reviews)</span>
            </div>
         
            <div class="mb-4">
                <h5>Size:</h5>
                <div class="btn-group" role="group" aria-label="Color selection" >
                    <input type="radio" class="btn-check" name="size" id="small" autocomplete="off" [(ngModel)]="selectProduct.size" [value]="'S'" checked>
                    <label class="btn btn-outline-dark" for="small">S</label>
                    <input type="radio" class="btn-check" name="size" id="medium" autocomplete="off" [(ngModel)]="selectProduct.size" [value]="'M'">
                    <label class="btn btn-outline-dark" for="medium">M</label>
                    <input type="radio" class="btn-check" name="size" id="large" autocomplete="off" [(ngModel)]="selectProduct.size" [value]="'L'">
                    <label class="btn btn-outline-dark" for="large">L</label>
                    <input type="radio" class="btn-check" name="size" id="extraLarge" autocomplete="off" [(ngModel)]="selectProduct.size" [value]="'XL'">
                    <label class="btn btn-outline-dark" for="extraLarge">XL</label>
                </div>
            </div>
            <a href="#" (click)="openSizeChart()" style="color: black;" data-bs-toggle="modal" data-bs-target="#sizeChartModal">
  View Size Chart
</a>
            <div class="mb-4">
                <label for="quantity" class="form-label">Quantity:</label>
                <input type="number" class="form-control" id="quantity" [(ngModel)]="selectProduct.Quantity" name="quantity" min="1" style="width: 80px;">
            </div>
            <button class="btn btn-primary btn-lg mb-3 me-2 addToCart" (click)="addToCartApiCall(selectProduct)">
                    <i class="bi bi-cart-plus"></i> Add to Cart
                </button>
            <!-- <button class="btn btn-outline-secondary btn-lg mb-3" (click)="DeleteFromCartApiCall(selectProduct)">
                    Remove From Cart
                </button> -->
            <div class="mt-4">
                <h5>Specifications:</h5>
                <ul>
                    <li>100% Pure Cotton</li>
                    <li>220 GSM</li>
                    <li>Oversized</li>
                    <li>Round Neck</li>
                     <li>Casual Wear</li>
                      <li>Made In India</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="sizeChartModal" tabindex="-1" aria-labelledby="sizeChartLabel" aria-hidden="true">
  <div class="modal-dialog modal-md" style="margin-top: 74px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="sizeChartLabel" >Size Chart</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <img src="../../assets/img/sizeChart.jpeg" alt="Size Chart" class="img-fluid" />
      </div>
    </div>
  </div>
</div>

<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
<script>
    function changeImage(event, src) {
            document.getElementById('mainImage').src = src;
            document.querySelectorAll('.thumbnail').forEach(thumb => thumb.classList.remove('active'));
            event.target.classList.add('active');
        }
</script>